import React, { useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { CreateNoteItemViewModel } from './models'
import { CreateItemProps, createNotePayloadFromViewModel } from './utils'
import { formOptions } from '../Common/Fields/config'
import NoteFields from '../Common/NoteFields'

import LoadingIndicator from 'components/Common/Loading/LoadingIndicator'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useCreateTripItem } from 'tripPlanner/hooks/api/tripItem'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import { scrollToNewItemWithRetry } from 'tripPlanner/utils/scrollToNewItem'

function CreateNote(props: CreateItemProps) {
  const { tripId, defaultDate, rankSpec } = props

  const { closeModal, goBack } = useModalCallbacks()
  const methods = useForm<CreateNoteItemViewModel>({
    ...formOptions,
    defaultValues: {
      type: 'NOTE',
      sourceType: 'NA',
      startDate: defaultDate,
      isSectionHeader: false,
    },
  })
  const { handleSubmit } = methods

  const { mutate: createMutate, isLoading } = useCreateTripItem({
    onSuccess: (res) => {
      scrollToNewItemWithRetry(res.id)
      closeModal()
    },
  })

  const createNoteItem = useCallback(
    (viewModel: CreateNoteItemViewModel) => {
      createMutate({
        tripId,
        tripItem: createNotePayloadFromViewModel(viewModel),
        rankSpec,
      })
    },
    [createMutate, tripId, rankSpec],
  )

  return (
    <>
      <ModalHeader
        title="Add note"
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <FormProvider {...methods}>
        <ModalBody>
          <ModalContent>
            <NoteFields tripId={tripId} />
          </ModalContent>
        </ModalBody>

        <ModalFooter
          primaryActionProps={{
            onClick: handleSubmit(createNoteItem),
            children: 'Save',
            disabled: isLoading,
          }}
        />
      </FormProvider>
      {isLoading && <LoadingIndicator floating />}
    </>
  )
}

export default CreateNote
